<template>
  <div class="form">
    <h3>{{ expert ? $t('randevu.experts.add.title_edit') : $t('randevu.experts.add.title_new') }}</h3>

    <input v-model="form.name" :placeholder="$t('randevu.experts.add.name_placeholder')">
    <p v-if="!form.name && triedSubmit" class="error">{{ $t('randevu.experts.add.name_required') }}</p>

    <input v-model="form.email" :placeholder="$t('randevu.experts.add.email_placeholder')">
    <input v-model="form.phone" :placeholder="$t('randevu.experts.add.phone_placeholder')">

    <div class="actions">
      <button class="primary" @click="submit">{{ expert ? $t('randevu.experts.add.update') : $t('randevu.experts.add.add') }}</button>
      <button @click="$emit('close')">{{ $t('randevu.experts.add.cancel') }}</button>
    </div>

    <p v-if="error" class="error">{{ error }}</p>
  </div>
</template>

<script>
import { ref } from "vue";
import { useI18n } from "vue-i18n";
import axios from "axios";

export default {
  props: { expert: Object },
  setup(props, { emit }) {
    const { t } = useI18n();
    const form = ref(props.expert ? { ...props.expert } : { name: "", email: "", phone: "" });
    const error = ref(null);
    const triedSubmit = ref(false);

    const submit = async () => {
      triedSubmit.value = true;

      // İsim kontrolü
      if (!form.value.name || form.value.name.trim() === "") {
        return;
      }

      try {
        if (props.expert) {
          await axios.put(`/promo/user/my-experts/${props.expert.id}`, form.value);
        } else {
          await axios.post("/promo/user/my-experts", form.value);
        }
        emit("refresh");
        emit("close");
      } catch {
        error.value = t("randevu.experts.add.generic_error");
      }
    };

    return { form, submit, error, triedSubmit };
  }
};
</script>

<style scoped>
.form {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-bottom: 4rem;
}

input,
textarea {
  width: 100%;
}

.actions {
  display: flex;
  gap: 8px;
}

.primary {
  background: #106E35;
  color: #fff;
  border: none;
  padding: 8px 16px;
  cursor: pointer;
}

.error {
  color: #f44336;
  font-size: 1em;
}
</style>
